import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $state, $q, $stateParams) {
    var ctrl = Object.create(BaseCtrl);
    ctrl.init = function () {
        initialiseScopeVariables();
    };

    /* Private Functions*/
    function initialiseScopeVariables() {
        $scope.accountNumber = $stateParams.accountNumber;

        /* Quote Table config* - Passed into Job Summary Directive*/
        $scope.quoteTableConfig = {
            jobStatus: 'openNotBound',
            defaultJobStatus: 'openNotBound',
            issuedInLastXDays: 30,
            jobStatusOptions: {
                'last30Days': 'gateway.views.quote-detail.last30Days',
                'openNotBound': 'gateway.views.quote-detail.openNotBound',
                'openBound': 'gateway.views.quote-detail.openBound'
            },
            source: 'account',
            search: ''
        };
    }

    ctrl.newQuote = function () {
        if (!angular.isDefined($scope.accountInfo.accountNumber)) {
            return;
        }
        var state = $state.get('newQuote');
        $state.transitionTo(state, {
            'accountNumber': $scope.accountInfo.accountNumber
        });
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$q', '$stateParams'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/account/QuotesCtrl.js
// module id = 1696
// module chunks = 0